module.exports = "/_next/static/images/fc97ede22f851f25fa269f978931401b-card-lock-icon.svg";